
/* styles */
require("!!vue-style-loader!css-loader?{\"minimize\":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-777e6790\",\"scoped\":false,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./primary-button.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./primary-button.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-777e6790\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./primary-button.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/utils/components/primary-button.vue
// module id = 69
// module chunks = 93